import { render, staticRenderFns } from "./o-accordion.vue?vue&type=template&id=0386a5b6&scoped=true&"
import script from "./o-accordion.vue?vue&type=script&lang=js&"
export * from "./o-accordion.vue?vue&type=script&lang=js&"
import style0 from "./o-accordion.vue?vue&type=style&index=0&id=0386a5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386a5b6",
  null
  
)

export default component.exports